import { createFileRoute } from "@tanstack/react-router";

import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

import { SectionRoute } from "@/components/shared/SectionRoute";
import { useTranslation } from "react-i18next";
import { PlaceholderSection } from "@/components/placeholder-sections/PlaceholderSection";

export const Route = createFileRoute("/dashboard/support/")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: SupportPage,
});

function SupportPage() {
  const { t } = useTranslation();

  return (
    <div className="pb-8">
      <SectionRoute
        route_one={t("routes.dashboard")}
        route_two={t("routes.support")}
      />
      <div className="mb-8 max-w-7xl mx-auto">
        <PlaceholderSection type="support" />
      </div>
    </div>
  );
}
